import React, { useEffect, useState } from "react";
import {
  Checkbox,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Box,
  CircularProgress,
} from "@mui/material";
import moment from "moment";
import InfiniteScroll from "react-infinite-scroll-component";
import { checkSubDomainAccess } from "../../../../../../../components/RolePermissionAccess/RolePermissionAccess";
import TableSkeleton from "../../../../../../../components/Skeletons/TableSkeleton";
import { PuffLoader } from "react-spinners";
import styles from "../../Meta.module.css";
import { setToastNotification } from "../../../../../../../components/ToastNotification/service/toastNotificationSlice";
import AutoCompleteField from "../../../../../../../components/AutoCompleteField/AutoCompleteField";
import SaveBtn from "../../../../../../../components/Buttons/SaveBtn";
import { resetLeadCreateSuccess } from "../../../../../Nurture/service/nurtureSlice";
import { useAuthUser } from "react-auth-kit";
import { useSelector } from "react-redux";
import { nurtureLead } from "../../../../../Nurture/service/nurtureSlice";
import { NurtureLead } from "../../../../../Nurture/service/types";
import { useDispatch } from "react-redux";
import AddLeadPayment from "../../../../../Nurture/components/AddLeadPayment";
import { getSubDomainAccessStatus } from "../../../../../../../components/RolePermissionAccess/RolePermissionAccess";
import { getCombinedAssignees } from "../../../../../../../components/CommonFunctions/CommonFunctions";
import {
  getMetaContact_List,
  getStreams,
  getStreamsForBranch,
  metaContactToLead,
} from "../../../../service/IntegrationsSlice";
import { GetMetaContact_list } from "../../../../service/integrations.request";
import { resetDeleteEntitySuccess } from "../../../../../../../service/activeInstituteSlice";
import RefreshIcon from "@mui/icons-material/Refresh";
import { openLeadExpandModal } from "../../../../../../../components/LeadPopup/hooks/useLeadCard";

const StyledTableCellHead = styled(TableCell)(({ theme }) => ({
  fontFamily: "Poppins",
  fontWeight: "400",
  lineHeight: "18px",
  fontSize: "14px",
  color: "#FFFFFF",
  textTransform: "capitalize",
  padding: theme.spacing(1),
}));

const StyledTableCellBody = styled(TableCell)(({ theme }) => ({
  fontFamily: "Poppins",
  fontWeight: "400",
  fontSize: "13px",
  color: "#142C44",
  padding: theme.spacing(1),
  paddingTop: "15px",
  paddingBottom: "10px",
}));

const responseTypeArray = [
  { type: "ALL", label: "All" },
  { type: "LEAD", label: "Leads" },
  { type: "CONTACT", label: "Contacts" },
  { type: "STUDENT", label: "Students" },
];
function ResponsesTab(props: any) {
  const { executeFunc, handleExecuteFunonLoad } = props;
  const { userById } = useSelector((state: any) => state.userDetails);
  const hasAllBranchAccess = getSubDomainAccessStatus(
    "GLOBAL_PERMISSIONS",
    "BRANCH_ACCESS",
    "ALL_BRANCHES",
    userById?.rolePermission
  );
  const hasLeadCardPermission = checkSubDomainAccess(
    "NURTURE_BOARD",
    "LEAD_CARD",
    userById?.rolePermission
  );
  const auth = useAuthUser();
  const authUser = auth();
  const dispatch = useDispatch();
  const activeInstitute = JSON.parse(localStorage.getItem("ACTIVE_INSTITUTE")!);

  const {
    metaContact_list,
    streamById,
    metaContactToLeadSuccess,
    metaContactToLeadError,
    metaContact_listLoading,
    metaContact_listSuccess,
    metaStreams,
    metaStreamsForBranch,
  } = useSelector((state: any) => state.appIntegrations);
  const { deleteEntitySuccess, deleteEntityLoading, deleteEntityError } =
    useSelector((state: any) => state.activeInstitute);
  const { leadCreatedId } = useSelector((state: any) => state.nurture);
  const leadSuccess = useSelector(
    (state: any) => state.nurture.leadCreateSuccess
  );
  const leadLoading = useSelector(
    (state: any) => state.nurture.leadCreateLoading
  );
  const [isPaginating, setIsPaginating] = React.useState(false);

  const [contactList, setContactList] = useState<any>({
    data: [],
    hasMore: false,
    lastEvaluatedKey: {},
  });
  const [leftHandSideLoader, setLeftHandSideLoader] = useState(false);
  const [rightHandSideLoader, setRightHandSideLoader] = useState(false);
  const [selectedContacts, setSelectedContacts] = useState<any>([]);
  const [showRightSideSelectors, setShowRightSideSelectors] = useState(false);
  const [clickApplyButton, setClickApplyButton] = useState(false);
  //Add Contact to lead side form
  const [formDetails, setFormDetails] = useState<any>();
  const [showEnquiryModal, setShowEnquiryModal] = useState(false);
  const [dataForEnquiry, setDataForEnquiry] = useState<any>();
  const [responseId, setResponseId] = useState("");
  const [showAddLeadWideView, setAddLeadWideView] = useState(false);

  const contactItems = contactList?.data?.filter(
    (item: any) => item?.tag !== "LEAD" && item?.tag !== "STUDENT"
  );
  const capitalize = (str?: string) => {
    if (!str) return "";
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const isAllSelected =
    contactItems?.length > 0 &&
    contactItems.every((item: any) =>
      selectedContacts.some((selected: any) => selected.id === item.id)
    );

  const handleSelectAll = (e: any) => {
    if (e.target.checked) {
      const contactsToSelect = contactList?.data?.filter(
        (item: any) => item?.tag !== "LEAD" && item?.tag !== "STUDENT"
      );
      setSelectedContacts(contactsToSelect);
    } else {
      setSelectedContacts([]);
    }
  };

  function removeCountryCodeIfPresent(
    phoneNumber: string,
    countryCode: any
  ): string {
    const digits = phoneNumber?.replace(/\D/g, "");
    const code = (countryCode ?? "").toString().replace(/\D/g, "");

    if (digits && code && digits.startsWith(code)) {
      return digits.slice(code.length);
    }

    return digits || "";
  }

  const handleRowSelect = (e: any, item: any) => {
    if (e.target.checked) {
      setSelectedContacts((prev: any) => [...prev, item]);
    } else {
      setSelectedContacts((prev: any) =>
        prev.filter((data: any) => data.id !== item.id)
      );
    }
  };

  const handleNextPage = () => {
    const userFromLocalStorage = authUser?.institute[0];
    const lastEvaluatedKey = contactList.lastEvaluatedKey;
    const id = userFromLocalStorage.instituteId;
    const data: any = {
      getContact: true,
      instituteId: authUser?.institute[0].instituteId,
      streamId: [selectedStream?.id],
      streamBranchIds: !hasAllBranchAccess ? [userById?.branchId] : [],
      tag:
        selectedType?.type &&
        selectedType.type !== " " &&
        selectedType.type !== "ALL"
          ? [selectedType.type]
          : responseTypeArray
              .filter((item) => item.type !== "ALL")
              .map((item) => item.type),
      searchAfter: lastEvaluatedKey,
    };
    if (contactList?.hasMore) {
      setIsPaginating(true);
      GetMetaContact_list(data)
        .then((res: any) => {
          const newData = res?.data?.data?.data || [];
          const newLastEvaluatedKey = res?.data?.data?.searchAfter ?? null;
          const newhasMore = res?.data?.data?.hasMore
            ? res?.data?.data?.hasMore
            : false;

          const updatedRaw = {
            data: [...contactList.data, ...newData],
            lastEvaluatedKey: newLastEvaluatedKey || null,
            hasMore: newhasMore,
            count: [...contactList.data, ...newData]?.length,
          };

          setContactList(updatedRaw);
          const newContactItems = newData.filter(
            (item: any) => item?.tag !== "LEAD" && item?.tag !== "STUDENT"
          );
          const allSelected = contactList.data
            .filter(
              (item: any) => item?.tag !== "LEAD" && item?.tag !== "STUDENT"
            )
            .every((item: any) =>
              selectedContacts.some((sel: any) => sel.id === item.id)
            );
          //   const newContactItems = newData.filter(
          //     (item: any) => item.tag === "CONTACT"
          //   );
          //   const allSelected = contactList.data
          //     .filter((item: any) => item.tag === "CONTACT")
          //     .every((item: any) =>
          //       selectedContacts.some((sel: any) => sel.id === item.id)
          //     );

          if (allSelected) {
            setSelectedContacts((prev: any[]) => {
              const newUnique = newContactItems.filter(
                (newItem: any) =>
                  !prev.some((oldItem) => oldItem.id === newItem.id)
              );
              return [...prev, ...newUnique];
            });
          }
        })
        .catch((err: any) => {})
        .finally(() => {
          setIsPaginating(false);
        });
    }
  };

  const [streamsList, setStreamsList] = useState<any[]>([]);
  const branches = useSelector((state: any) => state.branch.branchList);
  const [type, setType] = useState("");
  const courses = useSelector((state: any) => state.courses.courses);
  const activeCourses = courses?.filter(
    (item: any) => item?.status === "ACTIVE"
  );
  const filteredBranchList = hasAllBranchAccess
    ? branches
    : branches?.filter((branch: any) => branch.id === userById?.branchId);
  const teamMembers = useSelector((state: any) => state.staff.staffList);
  const batches = useSelector((state: any) => state.batch.batchList);
  const batchList = batches?.filter(
    (item: any) =>
      item?.batchConductType === "REGULAR_BATCH" && item?.status === "ACTIVE"
  );

  const [selectedStream, setSelectedStream] = useState<any>(null);
  const [selectedType, setSelectedType] = useState<any>(null);
  const [selectedCourse, setSelectedCourse] = useState<any>(null);

  const [selectedBranch, setSelectedBranch] = useState<any>(null);
  const [selectedBatch, setSelectedBatch] = useState<any>(null);
  const [selectedAssignee, setSelectedAssignee] = useState<any>(null);
  const filteredBatches = batchList?.filter((batch: any) => {
    const courseMatch =
      selectedCourse?.id === "" || batch.courseId === selectedCourse?.id;
    const branchMatch =
      selectedBranch?.id === "" || batch.branchId === selectedBranch?.id;
    const regularBatch =
      batch.batchConductType === "REGULAR_BATCH" &&
      batch.batchStatus !== "COMPLETED" &&
      batch.status !== "INACTIVE";

    return courseMatch && branchMatch && regularBatch;
  });

  const formattedBatches = filteredBatches?.map((batch: any) => ({
    ...batch,
    batchName: capitalize(batch.batchName),
  }));

  function getFormattedDate(date: any) {
    return moment(date).format("MMM Do, hh:mm A");
  }

  const onStreamChange = React.useCallback(
    (event: object, value: any | null) => {
      /* resetStreamById(); */
      if (value !== null) {
        setSelectedStream(value);
      } else {
        setSelectedStream(null);
      }
    },

    []
  );

  const onTypeChange = React.useCallback((event: object, value: any | null) => {
    if (value !== null) {
      setSelectedType(value);
    } else {
      setSelectedType(null);
    }
  }, []);
  const combinedAssignees = getCombinedAssignees(
    teamMembers,
    selectedBranch?.id
  )?.map((item: any) => ({
    ...item,
    fullName: `${capitalize(item?.firstName)} ${capitalize(item?.lastName)}`,
  }));
  const onCourseChange = React.useCallback(
    (event: object, value: any | null) => {
      setSelectedBatch(null);
      setSelectedAssignee(null);
      setSelectedBranch(null);
      if (value !== null) {
        setSelectedCourse(value);
        if (selectedBatch && selectedBatch?.courseId !== value.id) {
          setSelectedBatch(null);
        }
        if (selectedBranch && selectedBranch?.branchId !== value.id) {
          setSelectedBatch(null);
        }
      } else {
        setSelectedCourse(null);
      }
    },
    []
  );

  const onBranchChange = React.useCallback(
    (event: object, value: any | null) => {
      setSelectedBatch(null);
      setSelectedAssignee(null);
      if (value !== null) {
        setSelectedBranch(value);
      } else {
        setSelectedBranch(null);
      }
    },
    []
  );

  const onBatchChange = React.useCallback(
    (event: object, value: any | null) => {
      if (value !== null) {
        selectType(value);
        setSelectedBatch(value);
      } else {
        setSelectedBatch(null);
      }
    },
    []
  );
  const onAssigneeChange = React.useCallback(
    (event: object, value: any | null) => {
      if (value !== null) {
        setSelectedAssignee(value);
      } else {
        setSelectedAssignee(null);
      }
    },
    []
  );

  useEffect(() => {
    if (selectedContacts?.length > 0) {
      setShowRightSideSelectors(true);
    } else {
      setShowRightSideSelectors(false);
      setSelectedCourse(null);
      setSelectedBranch(null);
      setSelectedBatch(null);
      setSelectedAssignee(null);
    }
  }, [selectedType, selectedContacts]);
  const selectType = (value: any) => {
    const typeMapping: { [key: string]: string } = {
      ALL: "",
      CONTACTS: "CONTACT",
      LEADS: "ENQUIRY",
      STUDENTS: "BATCHSTUDENTMAPPING",
    };

    if (!value || value === "") {
      setType("");
      return "";
    }

    const mappedType = typeMapping[value.type] || "";
    setType(mappedType);
    return mappedType;
  };

  /* 	const handleMetaContactList = () => {
		if (selectedType?.type === 'CONTACTS') {
			setClickApplyButton(true);
		} else {
			setClickApplyButton(false);
		}

		const data: MetaContactListTypes = {
			instituteId: authUser?.institute[0].instituteId,
			streamId: selectedStream?.id,
			type: selectType(selectedType),
			limit: 10,
		};
		if (!hasAllBranchAccess) {
			data.branchId = authUser?.institute[0]?.branchId;
		}
		dispatch<any>(getMetaContactList(data));
		handleExecuteFunonLoad();

	};
 */
  const handleMetaContactList = (id: any) => {
    const streamId = id;
    if (typeof streamId === "string" && streamId.trim() !== "") {
      setSelectedContacts([]);
      setSelectedCourse([]);
      setSelectedBranch([]);
      setSelectedBatch([]);
      setSelectedAssignee([]);
      const url = new URL(window.location.href);

      url.searchParams.set("streamId", streamId);
      window.history.pushState({}, "", url);

      /* 	if (selectedType?.type === 'CONTACT') {
			setClickApplyButton(true);
		} else {
			setClickApplyButton(false);
		} */
      setLeftHandSideLoader(true);
      const data: any = {
        getContact: true,
        instituteId: authUser?.institute[0].instituteId,
        streamId: [streamId],
        streamBranchIds: !hasAllBranchAccess ? [userById?.branchId] : [],
        tag:
          selectedType?.type &&
          selectedType.type !== " " &&
          selectedType.type !== "ALL"
            ? [selectedType.type]
            : responseTypeArray
                .filter((item) => item.type !== "ALL")
                .map((item) => item.type),
      };

      dispatch<any>(getMetaContact_List(data));
      /* 	resetStreamById(); */
      handleExecuteFunonLoad();
    }
  };

  const handleMoveContactToLead = () => {
    setRightHandSideLoader(true);
    const studentsList = selectedContacts.map((item: any) => {
      return {
        studentFirstName: item.firstName,
        studentEmail: item.email,
        studentLastName: item.lastName ? item.lastName : "",
        otherDetails: item.otherDetails,
        studentContact: item.contactNumber,
        contactCountryCode: item.contactNoCountryCode,
        studentContactId: item.id,
        streamId: item.streamId,
      };
    });
    const dataToSend = {
      studentList: studentsList,
      createdByName: authUser?.firstName + " " + authUser?.lastName,
      status: "ACTIVE",
      createdById: authUser?.institute[0]?.id,
      messageId: "",
      instituteId: authUser?.institute[0]?.instituteId,
      instituteName: authUser?.institute[0]?.instituteName,
      createdTime: "",
      enquiryPriority: "NORMAL",
      enquirySource: "META",
      enquiryStatus: "NEW_ENQUIRY",

      courseId: selectedCourse?.id,
      courseName: selectedCourse?.courseName,

      branchId: selectedBranch?.id,
      branchName: selectedBranch?.branchName,

      batchId: selectedBatch?.id,
      batchName: selectedBatch?.batchName,

      assignedToId: selectedAssignee?.id,
      assignedToName:
        selectedAssignee?.firstName + " " + selectedAssignee?.lastName,
    };
    dispatch<any>(metaContactToLead(dataToSend));
  };

  const nurtureAddEnquiry = (data: NurtureLead) => {
    dispatch<any>(nurtureLead(data));
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("streamId");

    if (metaStreams) {
      const stream = metaStreams?.find((item: any) => item.id == id);

      setSelectedStream(stream);
      if (stream) {
        setSelectedType({ type: "ALL", label: "All" });
      }
      setStreamsList(
        metaStreams?.filter((item: any) => item.status !== "DRAFT")
      );
    } else {
      const stream = metaStreamsForBranch?.find((item: any) => item.id == id);
      setStreamsList(
        metaStreamsForBranch?.filter((item: any) => item.status !== "DRAFT")
      );

      setSelectedStream(stream);
      if (stream) {
        setSelectedType({ type: "ALL", label: "All" });
      }
    }
    setSelectedContacts([]);
    setContactList({ data: [], hasMore: false, lastEvaluatedKey: {} });
    // setSelectedType({ type: "ALL", label: "All" });
    if (id !== null || id !== undefined) {
      handleMetaContactList(id);
    }
  }, [metaStreams, metaStreamsForBranch]);

  useEffect(() => {
    if (metaContact_list) {
      setLeftHandSideLoader(false);
      setContactList({
        data: metaContact_list?.data,
        lastEvaluatedKey: metaContact_list?.searchAfter,
        hasMore: metaContact_list?.hasMore ? metaContact_list?.hasMore : false,
        count: metaContact_list?.data?.length,
      });
    }
  }, [metaContact_list]);

  useEffect(() => {
    if (!metaContactToLeadSuccess) return;

    // handleMetaContactList(selectedStream?.id);

    let count = 1; // First call already done

    const interval = setInterval(() => {
      if (count < 6) {
        handleMetaContactList(selectedStream?.id);
        count++;
      } else {
        clearInterval(interval);
      }
    }, 60 * 1000);

    // Cleanup
    return () => clearInterval(interval);
  }, [metaContactToLeadSuccess, selectedStream]);

  useEffect(() => {
    if (metaContactToLeadSuccess || leadSuccess || deleteEntitySuccess) {
      setRightHandSideLoader(false);
      /* 	setSelectedType({ type: 'CONTACT', label: 'Contacts' }); */
      setShowRightSideSelectors(false);
      handleMetaContactList(selectedStream?.id);
      setSelectedContacts([]);
      setDataForEnquiry(null);
      setSelectedCourse([]);
      setSelectedBranch([]);
      setSelectedBatch([]);
      setSelectedAssignee([]);
    } else if (metaContactToLeadError || metaContactToLeadError == undefined) {
      setRightHandSideLoader(false);
    } else {
      /* setTimeout(() => {
  				setRightHandSideLoader(false);
  			}, 200); */
    }
  }, [
    metaContactToLeadSuccess,
    metaContactToLeadError,
    leadSuccess,
    deleteEntitySuccess,
  ]);

  //   useEffect(() => {
  //     let timeoutId: NodeJS.Timeout;

  //     if (metaContactToLeadSuccess || leadSuccess || deleteEntitySuccess) {
  //       // Delay handleMetaContactList call by 3 seconds
  //       timeoutId = setTimeout(() => {
  //         setRightHandSideLoader(false);
  //         setShowRightSideSelectors(false);
  //         handleMetaContactList(selectedStream?.id);
  //         setSelectedContacts([]);
  //         setDataForEnquiry(null);
  //         setSelectedCourse([]);
  //         setSelectedBranch([]);
  //         setSelectedBatch([]);
  //         setSelectedAssignee([]);
  //       }, 3000);
  //     } else if (metaContactToLeadError || metaContactToLeadError === undefined) {
  //       setRightHandSideLoader(false);
  //     }

  //     // Clear timeout on unmount or dependency change
  //     return () => clearTimeout(timeoutId);
  //   }, [
  //     metaContactToLeadSuccess,
  //     metaContactToLeadError,
  //     leadSuccess,
  //     deleteEntitySuccess,
  //   ]);

  React.useEffect(() => {
    const regex = /^Congratulations! (.*) is a new Lead\.$/;
    if (regex.test(leadSuccess)) {
      dispatch<any>(resetLeadCreateSuccess());
    }
  }, [leadSuccess]);
  useEffect(() => {
    if (deleteEntityError || deleteEntitySuccess) {
      dispatch(resetDeleteEntitySuccess());
    }
  }, [deleteEntityError, deleteEntitySuccess]);
  // streams list (in drop down streams list)

  const getStreamData = (): void => {
    if (hasAllBranchAccess) {
      if (activeInstitute?.id)
        dispatch<any>(
          getStreams({ id: activeInstitute?.id, status: "", branchId: "" })
        );
    } else if (!hasAllBranchAccess && authUser?.institute[0]?.branchId) {
      dispatch<any>(getStreamsForBranch(authUser?.institute[0]?.branchId));
    }
  };

  useEffect(() => {
    getStreamData();
  }, []);

  // setting the streams list using setState

  React.useEffect(() => {
    if (leadSuccess !== true && leadSuccess !== false) {
      if (leadCreatedId === null || leadCreatedId === undefined) {
        setShowEnquiryModal(false);
      }
    }
  }, [leadSuccess, setShowEnquiryModal]);

  React.useEffect(() => {
    if (leadCreatedId && leadSuccess === "Converted lead is created.") {
      setAddLeadWideView(true);
      dispatch(
        setToastNotification({
          message: String("Please add the payment details for conversion"),
          type: "success",
          snackOpen: true,
        })
      );
    }
  }, [leadSuccess, setAddLeadWideView, leadCreatedId]);

  return (
    <div>
      <div className={styles.reponseHeader}>
        <div className={styles.reponseHeaderLeft}>
          <div style={{ width: "250px" }}>
            <AutoCompleteField
              options={streamsList}
              validState={true}
              placeholder={"Choose Stream"}
              id="stream"
              optionLabel={"streamName"}
              onChange={onStreamChange}
              value={selectedStream}
            />
          </div>
          <div style={{ width: "150px" }}>
            <AutoCompleteField
              options={responseTypeArray}
              validState={true}
              placeholder={"Choose Response Type"}
              optionLabel={"label"}
              value={selectedType}
              onChange={onTypeChange}
              id="type"
            />
          </div>

          <Button
            variant="contained"
            color="primary"
            sx={{
              fontSize: 14,
              textTransform: "capitalize",
              boxShadow: "none",
              height: "38px",
            }}
            size={"small"}
            onClick={() => handleMetaContactList(selectedStream?.id)}
            disabled={
              leftHandSideLoader ||
              selectedStream === null ||
              selectedType === null
            }
          >
            {leftHandSideLoader ? (
              <CircularProgress size={25} color={"inherit"} />
            ) : (
              "Apply"
            )}
          </Button>

          {/* <button
            onClick={() => handleMetaContactList(selectedStream?.id)}
            className={styles.refreshBtn}
            disabled={leftHandSideLoader}
          >
            <RefreshIcon
              style={{
                color: "grey",
                transform: leftHandSideLoader
                  ? "rotate(360deg)"
                  : "rotate(-360deg)",
                transition: "transform 0.3s ease-in-out",
              }}
            />
          </button> */}
        </div>
        <div>
          <Button
            variant="contained"
            color="primary"
            sx={{
              fontSize: 14,
              textTransform: "capitalize",
              boxShadow: "none",
              height: "38px",
            }}
            size={"small"}
            onClick={() => handleMetaContactList(selectedStream?.id)}
            disabled={leftHandSideLoader}
          >
            <RefreshIcon
              style={{
                color: "#fff",
                transform: leftHandSideLoader
                  ? "rotate(360deg)"
                  : "rotate(-360deg)",
                transition: "transform 0.3s ease-in-out",
              }}
              sx={{ marginRight: "8px", fontSize: "20px" }}
            />
            Sync
          </Button>
        </div>
      </div>
      <div className={styles.responseMoveWrap}>
        {showRightSideSelectors && (
          <div className={styles.reponseHeaderRight}>
            <div>
              <AutoCompleteField
                validState={true}
                border={false}
                placeholder={"Choose Course"}
                id="courseId"
                options={activeCourses}
                optionLabel={"courseName"}
                onChange={onCourseChange}
                value={selectedCourse}
                disableClearable={selectedCourse?.id === "" ? true : false}
                usedFor={"BULK_MOVE"}
              />
            </div>
            <div>
              <AutoCompleteField
                validState={true}
                border={false}
                placeholder={"Choose Branch"}
                id="branchId"
                options={filteredBranchList}
                optionLabel={"branchName"}
                onChange={onBranchChange}
                value={selectedBranch}
                disableClearable={selectedBranch?.id === "" ? true : false}
              />
            </div>
            <div>
              <AutoCompleteField
                validState={true}
                border={false}
                placeholder={"Choose Batch"}
                id="batchId"
                options={formattedBatches}
                optionLabel={"batchName"}
                onChange={onBatchChange}
                value={selectedBatch}
                disableClearable={selectedBatch?.id === "" ? true : false}
              />
            </div>
            <div>
              <AutoCompleteField
                validState={true}
                border={false}
                placeholder={"Choose Assign"}
                id="assigneeId"
                options={combinedAssignees}
                optionLabel={"fullName"}
                onChange={onAssigneeChange}
                value={selectedAssignee}
                disableClearable={selectedAssignee?.id === "" ? true : false}
              />
            </div>
            <div>
              <SaveBtn
                disabled={rightHandSideLoader == true}
                buttonText={
                  rightHandSideLoader == true ? (
                    <CircularProgress size={25} color={"inherit"} />
                  ) : (
                    "Move"
                  )
                }
                minWidth="74px"
                onClick={handleMoveContactToLead}
              />
            </div>
          </div>
        )}
      </div>
      <div style={{ minHeight: "500px" }}>
        {metaContact_listLoading && contactList === null ? (
          <TableSkeleton />
        ) : !selectedStream || !selectedType ? (
          <Box
            style={{
              border: "1px solid #E3E3E3",
              width: "100%",
              padding: "30px",
              boxShadow: "0px 20px 60px rgba(241, 244, 248, 0.5)",
              borderRadius: "6px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              Please Select stream and type from above dropdown
            </div>
          </Box>
        ) : metaContact_listSuccess && contactList?.data?.length === 0 ? (
          <Box
            style={{
              border: "1px solid #E3E3E3",
              width: "100%",
              padding: "30px",
              boxShadow: "0px 20px 60px rgba(241, 244, 248, 0.5)",
              borderRadius: "6px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              No Data found for selected stream and type
            </div>
          </Box>
        ) : (
          contactList?.data?.length > 0 &&
          selectedStream &&
          selectedType && (
            <div
              style={{
                borderRadius: "6PX",
                border: "1px solid #EAECF0",
                overflow: "hidden",
              }}
            >
              <TableContainer sx={{ borderRadius: "6px" }}>
                <InfiniteScroll
                  dataLength={contactList?.data?.length ?? 0}
                  next={handleNextPage}
                  hasMore={contactList?.hasMore}
                  loader={
                    isPaginating ? (
                      <Box
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {<PuffLoader color="#36d7b7" />}
                      </Box>
                    ) : null
                  }
                  height={"calc(100vh - 300px)"}
                >
                  <Table
                    sx={{
                      minWidth: 700,
                    }}
                  >
                    <TableHead
                      sx={{
                        position: "sticky",
                        top: 0,
                        zIndex: 999,
                        background: "#073E53",
                      }}
                    >
                      <TableRow>
                        <StyledTableCellHead>
                          <Checkbox
                            sx={{
                              strokeWidth: 1,
                              color: "#fff",
                            }}
                            checked={
                              isAllSelected &&
                              contactList?.data.length > 0 &&
                              selectedContacts.every(
                                (item: any) =>
                                  item?.tag !== "LEAD" &&
                                  item?.tag !== "STUDENT"
                              )
                            }
                            onChange={handleSelectAll}
                            disabled={
                              contactList?.data?.filter(
                                (item: any) =>
                                  item?.tag !== "LEAD" &&
                                  item?.tag !== "STUDENT"
                              )?.length === 0
                            }
                          />
                        </StyledTableCellHead>
                        <StyledTableCellHead
                          sx={{ minWidth: 300, padding: "16px" }}
                        >
                          Name (
                          {(selectedContacts?.length ?? 0) > 0
                            ? selectedContacts.length
                            : contactList?.count ?? 0}
                          )
                        </StyledTableCellHead>
                        <StyledTableCellHead sx={{ minWidth: 250 }}>
                          Email address
                        </StyledTableCellHead>
                        <StyledTableCellHead sx={{ minWidth: 200 }}>
                          Phone number
                        </StyledTableCellHead>
                        <StyledTableCellHead sx={{ minWidth: 180 }}>
                          Course
                        </StyledTableCellHead>

                        <StyledTableCellHead sx={{ minWidth: 200 }}>
                          Batch
                        </StyledTableCellHead>
                        <StyledTableCellHead sx={{ minWidth: 180 }}>
                          Source
                        </StyledTableCellHead>
                        <StyledTableCellHead sx={{ minWidth: 240 }}>
                          Date & Time
                        </StyledTableCellHead>
                        <StyledTableCellHead sx={{ minWidth: 200 }}>
                          Actions
                        </StyledTableCellHead>
                      </TableRow>
                    </TableHead>
                    <TableBody sx={{ background: "#fff" }}>
                      {contactList?.data?.map((report: any, index: any) => (
                        <TableRow key={index}>
                          <StyledTableCellBody>
                            <Checkbox
                              sx={{
                                strokeWidth: 1,
                                color:
                                  "hsla(220.6451612903226, 13.191489361702127%, 46.07843137254902%, 0.3)",
                              }}
                              checked={
                                selectedContacts.some(
                                  (data: any) => data?.id === report.id
                                ) && contactList?.data.length > 0
                              }
                              disabled={
                                report?.tag == "STUDENT" ||
                                report?.tag == "LEAD"
                              }
                              onChange={(e) => handleRowSelect(e, report)}
                            />
                          </StyledTableCellBody>
                          <StyledTableCellBody
                            sx={{
                              textTransform: "capitalize",
                            }}
                          >
                            <div
                              onClick={() => {
                                if (
                                  report?.tag !== "LEAD" &&
                                  report?.tag !== "STUDENT"
                                ) {
                                  const updated = {
                                    ...report,
                                    contactNumber: removeCountryCodeIfPresent(
                                      report.contactNumber,
                                      report.contactNoCountryCode
                                    ),
                                  };

                                  setDataForEnquiry(updated);
                                  setResponseId(report?.id);
                                  const isOtherDetailsEmpty =
                                    report &&
                                    Object.keys(report.otherDetails).length ===
                                      0;

                                  const transformedData = [
                                    {
                                      type: "Name",
                                      value:
                                        report &&
                                        report?.firstName +
                                          " " +
                                          report?.lastName,
                                    },
                                    {
                                      type: "Email",
                                      value: report && report?.email,
                                    },
                                    {
                                      type: "Contact",
                                      value: report && report?.contactNumber,
                                    },
                                    {
                                      otherDetails:
                                        report && report?.otherDetails,
                                    },
                                  ];

                                  const transformedDataWithoutOtherDetails = [
                                    {
                                      type: "Name",
                                      value:
                                        report &&
                                        report?.firstName +
                                          " " +
                                          report?.lastName,
                                    },
                                    {
                                      type: "Email",
                                      value: report && report?.email,
                                    },
                                    {
                                      type: "Contact",
                                      value: report && report?.contactNumber,
                                    },
                                  ];
                                  setFormDetails(
                                    isOtherDetailsEmpty
                                      ? transformedDataWithoutOtherDetails
                                      : transformedData
                                  );
                                  setShowEnquiryModal(true);
                                }
                              }}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                cursor:
                                  report?.tag !== "LEAD" ||
                                  report?.tag !== "STUDENT"
                                    ? "pointer"
                                    : "default",
                              }}
                            >
                              {report?.firstName + " " + report?.lastName}

                              <span
                                style={{ marginLeft: "8px" }}
                                className={styles.responseTag}
                              >
                                {report?.tag?.toLowerCase()?.replace(/_/g, " ")}
                              </span>
                            </div>
                          </StyledTableCellBody>
                          <StyledTableCellBody sx={{ color: "#0766FE" }}>
                            {report?.email}
                          </StyledTableCellBody>
                          <StyledTableCellBody>
                            {`+${
                              report?.contactNoCountryCode
                            } ${removeCountryCodeIfPresent(
                              report?.contactNumber,
                              report?.contactNoCountryCode
                            )}`}
                          </StyledTableCellBody>
                          <StyledTableCellBody>
                            {report?.courseName}
                          </StyledTableCellBody>
                          <StyledTableCellBody>
                            {report?.batchName}{" "}
                          </StyledTableCellBody>
                          <StyledTableCellBody
                            sx={{
                              color: "#0766FE",
                              textTransform: "uppercase",
                            }}
                          >
                            {report?.contactSource.toUpperCase()}
                          </StyledTableCellBody>

                          <StyledTableCellBody>
                            {getFormattedDate(report?.createdTime)}
                          </StyledTableCellBody>
                          <StyledTableCellBody>
                            {(report?.tag == "LEAD" ||
                              report?.tag == "STUDENT") && (
                              <button
                                onClick={() =>
                                  hasLeadCardPermission
                                    ? openLeadExpandModal(
                                        report?.instituteId,
                                        report?.contactNumber,
                                        report?.email,
                                        report?.enquiryId,
                                        dispatch,
                                        ""
                                      )
                                    : dispatch(
                                        setToastNotification({
                                          message: String(
                                            "You do not have permission to access the lead card"
                                          ),
                                          type: "error",
                                          snackOpen: true,
                                        })
                                      )
                                }
                                className={styles.streamActionBtn}
                              >
                                View lead card
                              </button>
                            )}
                          </StyledTableCellBody>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </InfiniteScroll>
              </TableContainer>
            </div>
          )
        )}
      </div>
      {showEnquiryModal && (
        <AddLeadPayment
          leadCreateLoading={leadLoading}
          show={showEnquiryModal}
          selectedValue={dataForEnquiry && dataForEnquiry?.email}
          messageId={""}
          onHide={() => {
            setShowEnquiryModal(false);
          }}
          nurtureAddEnquiry={nurtureAddEnquiry}
          isEmailDetail={false}
          leadCreateSuccess={leadSuccess && leadSuccess}
          isSourceWidth={false}
          isFromWebform={false}
          isFromMeta={true}
          isFromContacts={false}
          selectedRowDetails={dataForEnquiry && dataForEnquiry}
          responseId={responseId}
          formId={selectedStream?.id}
          /* formDetails={formDetails} */
          page={"META"}
          showAddLeadWideView={showAddLeadWideView}
          setAddLeadWideView={setAddLeadWideView}
          leadCreatedId={leadCreatedId}
        />
      )}
    </div>
  );
}

export default ResponsesTab;
